// Renders a list of completed visits. Viewed at route /visits.

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { cloneDeep, forEach } from 'lodash';
import List from '../../components/List';
import { changeRoute, highlightNavbarSection } from '../../root/actions';
import { dispatch } from '../../root/store';
import RightCarot from '../../assets/icons/carat_right.svg';
import { Outlet } from 'react-router-dom';

export class PastVisits extends Component {
  render() {
    const items = cloneDeep(this.props.pastVisits);
    const action = this.props.changeRoute;
    const itemsWithIcons = forEach(
      items,
      value => (value.icon = { src: RightCarot })
    );

    const listProps = { items: itemsWithIcons, action };

    return (
      <div className="mobile-padding">
        <h2>Past Visits</h2>
        <br />
        <br />
        <List {...listProps} />
        <Outlet />
      </div>
    );
  }

  componentDidMount() {
    dispatch(highlightNavbarSection('history'));
  }
}

const mapStateToProps = state => {
  return {
    pastVisits: state.containers.app.get('history')
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ changeRoute }, dispatch);
};

PastVisits.propTypes = {
  pastVisits: PropTypes.object,
  changeRoute: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(PastVisits);
